import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Route, Link } from 'react-router';

import {
	Well,
	Table,
	Breadcrumb,
	Col,
	BPanel,
	Icon,
	Checkbox,
	Button,
	FormControl,
	Alert,
	ListGroup,
	ListGroupItem,
	Panel,
	PanelBody,
	PanelContainer
} from '@sketchpixy/rubix';

export const PlanificationGroup = ({
	groupKey,
	items,
	pilots,
	montgolfieres,
	onChange
}) => {
	let pilotRef = null;
	let montgolfiereRef = null;

	return (
		<div>
			{ pilots.length > 0 &&
				<PanelContainer>
						<Panel>
						  <PanelBody style={{padding: 0}}>
								<Col sm={12}>
									<FormControl componentClass="select" type="select" placeholder="Pilote..." inputRef={(input) => { pilotRef = input; }}>
										{ _.reject(pilots, (pilot) => { return _.find(items, {_id: pilot._id }); }).map((pilot) =>
											<option value={pilot._id} key={pilot._id}>{ pilot.displayName() }</option>
										)}
									</FormControl>
								</Col>
								<br/><br/>
								<Col sm={6}>
									<Button bsStyle="success" onClick={() => onChange(groupKey, pilotRef && pilotRef.value, "user", true)}>Disponible</Button>
								</Col>
								<Col sm={6}>
									<Button bsStyle="danger" onClick={() => onChange(groupKey, pilotRef && pilotRef.value, "user", false)}>Indisponible</Button>
								</Col>

								<Col sm={12}>
									<br/>
									<ListGroup>
										{ _.filter(items, {target: "user"})
											.map((item) =>
												<ListGroupItem key={item._id} bsStyle={ item.isAvailable ? 'success' : 'danger' }><Icon glyph="glyphicon-remove" onClick={() => onChange(groupKey, item._id, "pilot", undefined)} /> &nbsp;{ _.find(pilots, {_id: item._id}).displayName() }</ListGroupItem>
										)}
									</ListGroup>
									<hr/>
								</Col>
						</PanelBody>
					</Panel>
				</PanelContainer>
			}

			{ montgolfieres.length > 0 &&
				<PanelContainer>
						<Panel>
						  <PanelBody style={{padding: 0}}>
								<Col sm={12}>
									<FormControl componentClass="select" type="select" placeholder="Montgolfieres..." inputRef={(input) => { montgolfiereRef = input; }}>
										{ _.reject(montgolfieres, (montgolfiere) => { return _.find(items, {_id: montgolfiere._id }); }).map((montgolfiere) =>
											<option value={montgolfiere._id} key={montgolfiere._id}>{ montgolfiere.name }</option>
																																)}
									</FormControl>
								</Col>
								<br/><br/>
								<Col sm={6}>
									<Button bsStyle="success" onClick={() => onChange(groupKey, montgolfiereRef && montgolfiereRef.value, "montgolfiere", true)}>Disponible</Button>
								</Col>
								<Col sm={6}>
									<Button bsStyle="danger" onClick={() => onChange(groupKey, montgolfiereRef && montgolfiereRef.value, "montgolfiere", false)}>Indisponible</Button>
								</Col>

								<Col sm={12}>
									<br/>
									<ListGroup>
										{ _.filter(items, { target: "montgolfiere" })
											.map((item) =>
												<ListGroupItem key={item._id} bsStyle={ item.isAvailable ? 'success' : 'danger' }><Icon glyph="glyphicon-remove" onClick={() => onChange(groupKey, item._id, "montgolfiere", undefined)} /> &nbsp;{ _.find(montgolfieres, {_id: item._id}).name }</ListGroupItem>
										)}
									</ListGroup>
								</Col>
							</PanelBody>
						</Panel>
					</PanelContainer>
			}
		</div>
	);
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/planifications/PlanificationGroup.component.js
 **/